import { DevicesForDeviceListFragment } from '@designage/gql';

export interface IDeviceState {
  device?: DevicesForDeviceListFragment;
}

export const initialDeviceState: IDeviceState = {};
